// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"dropdown__msignaturepad___2vbQd","m-signature-pad--body":"dropdown__m-signature-pad--body___lCR10","m-signature-pad--footer":"dropdown__m-signature-pad--footer___vB5U1","description":"dropdown__description___1A5-S","button":"dropdown__button___2DkQd","clear":"dropdown__clear___XeDiK","save":"dropdown__save___2dUNf","m-signature-pad":"dropdown__m-signature-pad___iiLUE","github":"dropdown__github___1CT29","value":"dropdown__value___2VBs_","dropdown":"dropdown__dropdown___3kN1c","up":"dropdown__up___17Ipd","values":"dropdown__values___2H1H4"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/styles/dropdown.scss
// module id = 8hjH
// module chunks = client